import { createUuid } from '@core/utils';
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import {
  fetchJejuApplyList,
  fetchJejuCommon,
  fetchJejuTermList,
} from '@/api/jeju-youthdream';

const jejuYouthDreamQueryOptionsKeys = {
  termList: createUuid('jeju-term-list'),
  common: createUuid('jeju-common'),
  applyList: createUuid('jeju-apply-list'),
  cancel: createUuid('jeju-cancel'),
};

export const jejuYouthDreamQueryOptions = {
  termList: () =>
    queryOptions({
      queryKey: [jejuYouthDreamQueryOptionsKeys.termList],
      queryFn: fetchJejuTermList,
    }),
  common: () =>
    queryOptions({
      queryKey: [jejuYouthDreamQueryOptionsKeys.common],
      queryFn: fetchJejuCommon,
    }),
  applyList: (memberOauth?: number, policyApplyId?: number) => {
    const INITIAL_PAGE = 0;
    const PAGE_SIZE = 100;

    return infiniteQueryOptions({
      queryKey: [
        jejuYouthDreamQueryOptionsKeys.applyList,
        INITIAL_PAGE,
        memberOauth,
        PAGE_SIZE,
      ],
      enabled: !!memberOauth && policyApplyId === 2,
      queryFn: ({ pageParam = INITIAL_PAGE }) =>
        fetchJejuApplyList({
          socialId: memberOauth,
          page: pageParam,
          size: PAGE_SIZE,
        }),
      getNextPageParam: (page) => {
        if (page && page.pageable && page.pageable.pageNumber !== undefined) {
          const nextPage = page.pageable.pageNumber + 1;

          return page.last ? undefined : nextPage;
        }

        return undefined;
      },
      select: (data) => {
        const details = data.pages.flatMap((page) =>
          page.content ? page.content : [],
        );

        const totalCount = data.pages[0]?.totalElements || 0;

        return { details, totalCount };
      },
      initialPageParam: INITIAL_PAGE,
    });
  },
};
